;(function ( $ ) {

    /**
     *  formTicketPreview
     *  show ticket preview after entering all required info
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'formTicketPreview';
    var defaults = {
        scrollEasing: 'easeInOutCubic',
        scrollDuration: 300
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {

        init: function () {
            this.$overlayContainer = $(this.element).parents('.overlay-content');
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            $(this.element).on('submit', function(e) {
                if ($(this).find('.has-error').length) {
                    e.preventDefault();
                }
            });

            $(this.element).find('.show-ticket-preview').on('click', function(e) {
                e.preventDefault();
                $(window).trigger('form.validate-do');
            });

            $(window).on('form.valid', function() {
                if ($(_this.element).find('.show-ticket-preview').length) {
                    _this.showTicketPreview();
                    $(window).trigger('ticketpreview.show');
                }
            });

            $(this.element).find('.button.edit').on('click', function(e) {
                e.preventDefault();
                $(window).trigger('ticketform.show');
            });

            $(window).on('ticketform.show', function() {
                _this.showTicketForm();
            });

            $(this.element).find('.button.submit-and-restart').on('click', function(e) {
                e.preventDefault();
                $(_this.element).find('input[name="restart"]').val('true');
                $(_this.element).addClass('overlay-gray');
                $(_this.element).openOverlay();
                $(_this.element).submit();
            });

            $(this.element).find('.button.submit').on('click', function(e) {
                e.preventDefault();
                $(_this.element).find('input[name="restart"]').val('false');
                $(_this.element).submit();
            });
        },

        showTicketPreview: function() {
            if ($(this.element).find('input[name="ticket-personalize"]').is(':checked')) {
                var givenname;
                if ($(this.element).find('select[name="ticket-title"]').val() !== 'undefined') {
                    givenname = $(this.element).find('select[name="ticket-title"]').val() + ' ';
                }
                givenname += $(this.element).find('input[name="ticket-givenname"]').val();
                $(this.element).find('.ticket-preview-body').find('.givenname').text(givenname);
                $(this.element).find('.ticket-preview-body').find('.surname').text($(this.element).find('input[name="ticket-surname"]').val());
                $(this.element).find('.ticket-preview-body').find('.company').text($(this.element).find('input[name="ticket-company"]').val());
                $(this.element).find('.ticket-preview-body').find('.country').text($(this.element).find('select[name="ticket-country"]').find(':selected').text());
            } else {
                $(this.element).find('.ticket-preview-body').find('.givenname').text('…');
                $(this.element).find('.ticket-preview-body').find('.surname').text('…');
                $(this.element).find('.ticket-preview-body').find('.company').text('…');
                $(this.element).find('.ticket-preview-body').find('.country').text('…');
            }
            $(this.element).find('.form-row, .show-ticket-preview').hide();
            $(this.element).find('.form-ticket-preview').show();
            $('#atp-overlay').find('.overlay-back').addClass('edit');
            if (this.$overlayContainer.length) {
                this.$overlayContainer.animate({
                    'scrollTop': 0
                }, this.settings.scrollDuration, this.settings.scrollEasing);
            }
        },

        showTicketForm: function() {
            $(this.element).find('.form-ticket-preview').hide();
            $(this.element).find('.form-row, .show-ticket-preview').show();
            $('#atp-overlay').find('.overlay-back').removeClass('edit');
            if ($(this.element).find('#toggle-rows').length && !$(this.element).find('#toggle-rows').is(':checked')) {
                $(this.element).find('.form-row:not(.optinal-row)').show();
                
            } else {
                $(this.element).find('.form-row').show();
                
            }
            if (this.$overlayContainer.length) {
                this.$overlayContainer.animate({
                    'scrollTop': 0
                }, this.settings.scrollDuration, this.settings.scrollEasing);
            }
        }

    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
